import formFieldWidget from "./formFieldWidget.js";

/**
 * Coordinate picker field
 *
 * _Options:_
 * See formField for more options
 */
function coordinatesFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = formFieldWidget(spec, my);
	let xcoord;
	let ycoord;

	that.onchange = function () {
		const val = {
			x: xcoord.asJQuery().val(),
			y: ycoord.asJQuery().val(),
		};
		that.setValue(my.serialize(val));
	};

	my.renderFieldOn = function (html) {
		const coords = my.deserialize(that.getValue());

		html.render("X: ");

		xcoord = html.input({
			style: "width:20px",
			value: (coords && coords.x) || 0,
		});

		html.render(" Y: ");

		ycoord = html.input({
			value: (coords && coords.y) || 0,
			style: "width:20px",
		});

		// notify on change
		xcoord.blur(that.onchange);
		xcoord.change(that.onchange);
		ycoord.blur(that.onchange);
		ycoord.change(that.onchange);
	};

	my.deserialize = function (string) {
		const coords = {};
		try {
			coords.x = string.split(",")[0].trim();
			coords.y = string.split(",")[1].trim();
		} catch {
			return null;
		}

		return coords;
	};

	my.serialize = function (coords) {
		return `${coords.x} ,${coords.y}`;
	};

	return that;
}

export default coordinatesFieldWidget;
